import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { UserStore } from '../../core/stores/base.store';
import { Profile } from '../../core/models';

@Component({
  selector: 'app-add-user',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCardModule
  ],
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.css'
})
export class AddUserComponent implements OnInit {
  userForm!: FormGroup;
  isEditMode = false;
  selectedUser: Profile | null = null;
  
  private userStore = inject(UserStore);
  private fb = inject(FormBuilder);
  
  constructor(private router: Router) {
    this.selectedUser = this.userStore.selected();
    this.isEditMode = !!this.selectedUser;
  }
  
  ngOnInit(): void {
    this.initForm();
  }
  
  private initForm(): void {
    this.userForm = this.fb.group({
      email: [this.selectedUser?.email || '', [Validators.required, Validators.email]],
    });
  }
  
  onSubmit(): void {
    if (this.userForm.invalid) {
      return;
    }
    
    const formData = this.userForm.value;
    
    if (this.isEditMode && this.selectedUser) {
      const updatedUser: Profile = {
        ...this.selectedUser,
        ...formData
      };
      this.userStore.update(updatedUser);
    } else {
      const newUser: Profile = formData;
      delete newUser.id;
      delete newUser.uid;
      this.userStore.create({entity: newUser, endpoint: 'user'});
    }
    
    this.router.navigate(['/users']);
  }
  
  goBack(): void {
    this.router.navigate(['/users']);
  }
}
